import './EntityBulkTagTab.scss';
import { caseInsensitiveContainsFilterOption } from '@lib/filter';
import debounce from 'lodash/debounce';
import { haltClickEventPropagation } from '@lib/events';
import { Button, Select, Space, Tag } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useMemo, useState } from 'react';
import { useLinkTag, useQueryResource, useTags } from '@hooks';
export const EntityBulkTagTab = ({ sonarObjectId }) => {
    var _a;
    const fieldsUri = `v2/salesforce/SfEntityDefinitions/${sonarObjectId}/fields`;
    const checkUri = `v2/salesforce/SfEntityDefinitions/${sonarObjectId}/check-fields`;
    const [selectedFields, setSelectedFields] = useState();
    const [selectedTag, setSelectedTag] = useState();
    const tags = useTags(true);
    const { request: linkTag } = useLinkTag();
    const { loading, resource, updateParams } = useQueryResource({
        defaultParams: {
            count: 8,
            offset: 0
        },
        uri: fieldsUri
    });
    const { loading: checking, resource: fieldIdMatches, updateParams: updateFieldCheckParams } = useQueryResource({
        defaultParams: { fieldInternalNames: [] },
        uri: checkUri
    });
    const fieldSuggestions = (_a = resource === null || resource === void 0 ? void 0 : resource.results) !== null && _a !== void 0 ? _a : [];
    const debouncedUpdateParams = useMemo(() => debounce(updateParams, 300), [updateParams]);
    const handleSearchChange = useCallback((query) => debouncedUpdateParams({ query }), [debouncedUpdateParams]);
    const resetForm = useCallback(() => {
        setSelectedFields([]);
        setSelectedTag(undefined);
    }, []);
    const handleBulkTagClick = useCallback(() => {
        var _a;
        if (!selectedTag) {
            return;
        }
        linkTag({
            sonarObjectIds: (_a = fieldIdMatches === null || fieldIdMatches === void 0 ? void 0 : fieldIdMatches.map((item) => item.sonarObjectId)) !== null && _a !== void 0 ? _a : [],
            sonarObjectTagId: selectedTag
        });
        resetForm();
    }, [fieldIdMatches, linkTag, resetForm, selectedTag]);
    const tagRender = useCallback((tagProps) => {
        var _a;
        const { label, value, closable, onClose } = tagProps;
        const found = ((_a = fieldIdMatches === null || fieldIdMatches === void 0 ? void 0 : fieldIdMatches.findIndex((match) => match.internalName === value)) !== null && _a !== void 0 ? _a : -1) > -1;
        const statusIcon = found ? React.createElement(CheckCircleOutlined, null) : React.createElement(CloseCircleOutlined, null);
        const processing = !found && checking;
        return (React.createElement(Tag, { className: 'field-name-tag', closable: closable, color: found ? 'blue' : '', icon: processing ? React.createElement(SyncOutlined, { spin: true }) : statusIcon, onClose: onClose, onMouseDown: haltClickEventPropagation }, label));
    }, [fieldIdMatches, checking]);
    return (React.createElement("div", { className: 'bulk-tag' },
        React.createElement(Space, { direction: 'vertical' },
            React.createElement(Select, { allowClear: true, className: 'field-select', filterOption: caseInsensitiveContainsFilterOption, loading: loading || checking, mode: 'tags', onChange: (fieldInternalNames) => updateFieldCheckParams({ fieldInternalNames }), onSearch: handleSearchChange, options: fieldSuggestions.map((field) => ({
                    label: field.internalName,
                    value: field.internalName
                })), placeholder: PLACEHOLDERS_COPY.PASTE_FIELD_NAMES, tagRender: tagRender, tokenSeparators: [', ', '\n', '\r'], value: selectedFields }),
            React.createElement(Space, null,
                React.createElement(Select, { onChange: (id) => setSelectedTag(Number(id)), options: tags.filter((tag) => !tag.autoTagged)
                        .map((tag) => ({
                        label: tag.name,
                        value: tag.id
                    })), placeholder: COPY_SPECIFIC.SELECT_A_TAG, style: { width: 200 }, value: selectedTag }),
                React.createElement(Button, { disabled: !selectedTag || !(fieldIdMatches === null || fieldIdMatches === void 0 ? void 0 : fieldIdMatches.length), onClick: handleBulkTagClick, type: 'primary' }, COPY_SPECIFIC.BULK_TAG)))));
};
